import { useUser } from "hooks/use-user";
import CCAClosedTicketsList from "./callCenterAgentTickets/closed-tickets-list";
import DispatcherClosedTicketsList from "./dispatcherTickets/closed-tickets-list";
import { isCallCenterAgent } from "./utils";

export default function ClosedTicketsList() {
  const user = useUser();
  const isCCA = isCallCenterAgent(user);
  if (isCCA) {
    return <CCAClosedTicketsList />;
  }
  return <DispatcherClosedTicketsList />;
}
